jQuery(function ($) {
    $('#mda-variant-select').selectWoo({
        minimumResultsForSearch: Infinity,
        escapeMarkup: function (markup) { return markup; }, // ważne!
        templateResult: function (state) {
            // select2/selectWoo podaje tu obiekt z .text i .element
            if (!state.id) return state.text;
            var $option = $(state.element);
            var img = $option.data('img');

            if (img) {
                return '<span style="display:flex;align-items:center;">' +
                    '<img src="' + img + '" style="width:32px;height:32px;object-fit:cover;border-radius:5px;margin-right:8px;"> ' +
                    state.text +
                    '</span>';
            }
            return state.text;
        },
        templateSelection: function (state) {
            if (!state.id) return state.text;
            var $option = $(state.element);
            var img = $option.data('img');
            // if (img) {
            //     return '<span style="display:flex;align-items:center;">' +
            //         '<img src="'+img+'" style="width:32px;height:32px;object-fit:cover;border-radius:5px;margin-right:8px;"> ' +
            //         state.text +
            //         '</span>';
            // }
            return state.text;
        }
    });

    $('#mda-variant-select').on('change', function () {
        var sel = $(this).find(':selected');
        var priceHtml = sel.data('price-html');
        var stock = parseInt(sel.data('stock'), 10) || 1;
        var price = sel.data('price');
        var inStock = sel.data('in_stock') == '1';
        var pid = sel.val();

        $('.mda-variant-price').html('Cena wariantu: ' + priceHtml);
        $('.mda-variant-stock').text(inStock ? 'Dostępność: ' + stock + ' szt.' : 'Brak w magazynie');
        $('[name=add-to-cart]').val(pid);

        $('.single_add_to_cart_button').attr('data-base-price', price);

        var $qtyInput = $('.form-qty__input');
        var min = parseInt($qtyInput.attr('min')) || 1;
        $qtyInput.attr('max', stock);
        if (parseInt($qtyInput.val(), 10) > stock) {
            $qtyInput.val(stock);
        }
        var $minusBtn = $qtyInput.closest('.form-qty').find('.form-qty__button.-decrease');
        var $plusBtn = $qtyInput.closest('.form-qty').find('.form-qty__button.-increase');
        var current = parseInt($qtyInput.val(), 10);

        $minusBtn.toggleClass('-disabled', current <= min);
        $plusBtn.toggleClass('-disabled', current >= stock);

        const event = new CustomEvent('mda_variant_changed');
        document.dispatchEvent(event);
    });

});
